import React from 'react'
import ReactPaginate from 'react-paginate'

const Pagination = (props: any) => {
    const { handlePageClick, totalPages, forcePage, className = '' } = props
    return (
        <nav className={className}>
            <ReactPaginate
                breakLabel="..."
                nextLabel="Next"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={totalPages}
                forcePage={forcePage}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                previousLabel="Prev"
            />
        </nav>
    )
}

export default Pagination
